import { LegalLayout, Section } from "@/components/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" updated="giugno 2026" otherTo="/termini" otherLabel="Leggi i Termini e Condizioni →">
      <p data-testid="privacy-intro">
        La presente informativa descrive come <strong>MenuOne</strong> ("noi", il "Titolare") tratta i dati personali
        degli utenti del servizio, in conformità al Regolamento (UE) 2016/679 ("GDPR"), al D.lgs. 196/2003 (Codice
        Privacy) come modificato dal D.lgs. 101/2018 e ai provvedimenti del Garante per la protezione dei dati personali.
        Utilizzando MenuOne accetti le pratiche descritte in questa informativa.
      </p>

      <Section n="1" title="Titolare del trattamento">
        <p>
          Il Titolare del trattamento è <strong>Menuone</strong>, P.IVA <strong>03102260647</strong>, con sede in
          <strong> Sant'Angelo dei Lombardi (AV)</strong>. Per qualsiasi richiesta relativa ai tuoi dati personali o per
          l'esercizio dei tuoi diritti puoi scriverci a <a href="mailto:creamenuone@gmail.com" className="text-[#5aa469] hover:underline">creamenuone@gmail.com</a>.
        </p>
      </Section>

      <Section n="2" title="Quali dati raccogliamo">
        <p>Trattiamo esclusivamente i dati necessari a fornirti il servizio:</p>
        <ul className="list-disc pl-6 space-y-1.5">
          <li><strong>Dati di registrazione:</strong> nome, indirizzo email, password (conservata in forma cifrata) e nome della tua attività.</li>
          <li><strong>Dati del menù:</strong> categorie, piatti, descrizioni, prezzi, immagini e informazioni del locale che inserisci nella piattaforma.</li>
          <li><strong>Dati di pagamento:</strong> gestiti in modo sicuro dal fornitore di pagamento Stripe. MenuOne <strong>non</strong> memorizza i numeri completi della tua carta.</li>
          <li><strong>Dati tecnici:</strong> log di accesso, indirizzo IP e cookie tecnici necessari al funzionamento e alla sicurezza del servizio.</li>
        </ul>
      </Section>

      <Section n="3" title="Finalità e base giuridica">
        <ul className="list-disc pl-6 space-y-1.5">
          <li>Creazione e gestione dell'account e fornitura del servizio — base giuridica: esecuzione del contratto (art. 6.1.b GDPR).</li>
          <li>Gestione degli abbonamenti e dei pagamenti — esecuzione del contratto e obblighi legali/fiscali (art. 6.1.b e 6.1.c GDPR).</li>
          <li>Assistenza clienti e comunicazioni di servizio — esecuzione del contratto e legittimo interesse (art. 6.1.f GDPR).</li>
          <li>Adempimenti di legge e sicurezza della piattaforma — obbligo legale e legittimo interesse.</li>
        </ul>
      </Section>

      <Section n="4" title="Conservazione dei dati">
        <p data-testid="privacy-retention">
          I dati forniti in fase di registrazione sono conservati da MenuOne <strong>per tutta la durata dell'utilizzo del
          software</strong>. Nel momento in cui l'utente cancella il proprio account, i relativi dati vengono
          <strong> eliminati</strong> dai nostri sistemi. Fanno eccezione i soli dati la cui conservazione è imposta da
          obblighi di legge (ad esempio i documenti fiscali e contabili relativi ai pagamenti, conservati per il periodo
          previsto dalla normativa vigente).
        </p>
      </Section>

      <Section n="5" title="Comunicazione e destinatari dei dati">
        <p>I dati possono essere trattati, per nostro conto e in qualità di Responsabili del trattamento, da fornitori selezionati che ci aiutano a erogare il servizio:</p>
        <ul className="list-disc pl-6 space-y-1.5">
          <li><strong>Stripe</strong> — elaborazione dei pagamenti e degli abbonamenti.</li>
          <li><strong>Fornitore di hosting/cloud</strong> — archiviazione sicura dei dati.</li>
          <li><strong>Fornitore di posta transazionale</strong> — invio delle email di servizio (es. notifiche ordini).</li>
          <li><strong>Fornitori di servizi di intelligenza artificiale</strong> — generazione di descrizioni e traduzioni dei piatti, sui soli testi del menù.</li>
        </ul>
        <p>I dati non sono ceduti né venduti a terzi per finalità di marketing. Eventuali trasferimenti verso Paesi extra-UE avvengono nel rispetto delle garanzie previste dal GDPR (es. clausole contrattuali standard).</p>
      </Section>

      <Section n="6" title="I tuoi diritti">
        <p>In qualità di interessato puoi esercitare in ogni momento i diritti previsti dagli artt. 15–22 del GDPR:</p>
        <ul className="list-disc pl-6 space-y-1.5">
          <li>accesso ai tuoi dati e loro rettifica;</li>
          <li>cancellazione ("diritto all'oblio") e limitazione del trattamento;</li>
          <li>portabilità dei dati e opposizione al trattamento;</li>
          <li>revoca del consenso, ove il trattamento si basi sul consenso.</li>
        </ul>
        <p>
          Puoi esercitare i tuoi diritti scrivendo a <a href="mailto:creamenuone@gmail.com" className="text-[#5aa469] hover:underline">creamenuone@gmail.com</a>.
          Hai inoltre il diritto di proporre reclamo all'Autorità di controllo italiana, il
          <strong> Garante per la protezione dei dati personali</strong> (<a href="https://www.garanteprivacy.it" target="_blank" rel="noreferrer" className="text-[#5aa469] hover:underline">garanteprivacy.it</a>).
        </p>
      </Section>

      <Section n="7" title="Cancellazione dell'account">
        <p>
          Puoi cancellare il tuo account in qualsiasi momento dalla sezione <em>Account</em> della dashboard. La
          cancellazione comporta l'eliminazione dei dati di registrazione e dei contenuti del menù associati, come
          descritto al punto 4, e l'eventuale interruzione dell'abbonamento in corso.
        </p>
      </Section>

      <Section n="8" title="Cookie">
        <p>
          MenuOne utilizza cookie tecnici e di sessione necessari per l'autenticazione e per il corretto funzionamento
          della piattaforma. Sui menù pubblici dei locali con piano <strong>Free</strong> vengono mostrati annunci
          <strong> Google AdSense</strong>: Google può utilizzare cookie per mostrare annunci personalizzati solo previo
          consenso del visitatore, richiesto tramite apposito banner; in assenza di consenso vengono mostrati annunci non
          personalizzati. Maggiori informazioni: <a href="https://policies.google.com/technologies/ads" className="underline" target="_blank" rel="noreferrer">policies.google.com/technologies/ads</a>.
          I menù dei piani a pagamento non contengono pubblicità.
        </p>
      </Section>

      <Section n="9" title="Modifiche alla presente informativa">
        <p>
          Potremo aggiornare questa Privacy Policy per riflettere modifiche normative o del servizio. Le versioni
          aggiornate saranno pubblicate su questa pagina con la relativa data di aggiornamento.
        </p>
      </Section>
    </LegalLayout>
  );
}
